import { combineReducers } from 'redux';
import { userRequest } from './userRequest'
import { spendingRequest } from './spendingRequest'
import { categoryRequest } from './categoryRequest'
import { salaryRequest } from './salaryRequest'
import { employeeRequest } from './employeeRequest'
import { serviceRequest } from './serviceRequest'
import { functionRequest } from './functionRequest'
import { supplierRequest } from './supplierRequest'
import { labelRequest } from './labelRequest'
import { bankRequest } from './bankRequest'
import { paymentRequest } from './paymentRequest'
import { creditRequest } from './creditRequest'
import { debitRequest } from './debitRequest'
import { salaryCatRequest } from './salaryCatRequest'
import { chargeRequest } from './chargeRequest'
import { accessRequest } from './accessRequest'
import { projectRequest } from './projectRequest'
import { projectStepRequest } from './projectStepRequest'
import { timesheetRequest } from './timesheetRequest'
import { advanceRequest } from './advanceRequest'
import { advanceReturnRequest } from './advanceReturnRequest'
import { budgetRequest } from './budgetRequest'
import { postRequest } from './postRequest'
import { incomeRequest } from './incomeRequest'
import { factureRequest } from './factureRequest'
import { transferRequest } from './transferRequest'
import { chantierRequest } from './chantierRequest'
import { equipementRequest } from './equipementRequest';
import { vehiculeRequest } from './vehiculeRequest';
import { loanRequest } from './loanRequest';
import { loanDemandRequest } from './loanDemandRequest';
import { usageRequest } from './usageRequest';
import { localisationRequest } from './localisationRequest';
import { societyRequest } from './societyRequest';
import { demandRequest } from './demandRequest';
import { sessionRequest } from './sessionRequest';
import { articleRequest } from './articleRequest';
import { spendingDemandRequest } from './spendingDemandRequest';

export const initialState = {
    users:{
        fetching:false,
        fetched: false,
        error:null,
    },
    spendings:{
        fetching:false,
        fetched: false,
        error:null,
    },
    categories:{
        fetching:false,
        fetched: false,
        error:null,
    },
    salaries:{
        fetching:false,
        fetched: false,
        error:null,
    },
    employee:{
        fetching:false,
        fetched: false,
        error:null,
    },
    suppliers:{
        fetching:false,
        fetched: false,
        error:null,
    },
    labels:{
        fetching:false,
        fetched: false,
        error:null,
    },
    banks:{
        fetching:false,
        fetched: false,
        error:null,
    },
    payments:{
        fetching:false,
        fetched: false,
        error:null,
    },
    credits:{
        fetching:false,
        fetched: false,
        error:null,
    },
    debits:{
        fetching:false,
        fetched: false,
        error:null,
    },
    salary_cats:{
        fetching:false,
        fetched: false,
        error:null,
    },
    charges:{
        fetching:false,
        fetched: false,
        error:null,
    },
    services:{
        fetching:false,
        fetched: false,
        error:null,
    },
    functions:{
        fetching:false,
        fetched: false,
        error:null,
    },
    access:{
        fetching:false,
        fetched: false,
        error:null,
    },
    projects:{
        fetching:false,
        fetched: false,
        error:null,
    },
    timesheets:{
        fetching:false,
        fetched: false,
        error:null,
    },
    advances:{
        fetching:false,
        fetched: false,
        error:null,
    },
    advanceReturns:{
        fetching:false,
        fetched: false,
        error:null,
    },
    budgets:{
        fetching:false,
        fetched: false,
        error:null,
    },
    posts:{
        fetching:false,
        fetched: false,
        error:null,
    },
    incomes:{
        fetching:false,
        fetched: false,
        error:null,
    },
    factures:{
        fetching:false,
        fetched: false,
        error:null,
    },
    transfers:{
        fetching:false,
        fetched: false,
        error:null,
    },
    chantiers:{
        fetching:false,
        fetched: false,
        error:null,
    },
    steps:{
        fetching:false,
        fetched: false,
        error:null,
    },
    equipements:{
        fetching:false,
        fetched: false,
        error:null,
    },
    vehicules:{
        fetching:false,
        fetched: false,
        error:null,
    },
    loans:{
        fetching:false,
        fetched: false,
        error:null,
    },
    loanDemands:{
        fetching:false,
        fetched: false,
        fetchedAll: false,
        error:null,
    },
    usages:{
        fetching:false,
        fetched: false,
        error:null,
    },
    localisations:{
        fetching:false,
        fetched: false,
        error:null,
    },
    society:{
        fetching:false,
        fetched: false,
        error:null,
    },
    articles:{
        fetching:false,
        fetched: false,
        error:null,
    },
    demand:{
        fetching:false,
        fetched: false,
        error:null,
    },
    session:{
        fetching:false,
        fetched: false,
        error:null,
    },
};
export default combineReducers({
    users : userRequest,
    spendings : spendingRequest,
    spendingDemands : spendingDemandRequest,
    categories : categoryRequest,
    salaries : salaryRequest,
    employees : employeeRequest,
    suppliers : supplierRequest,
    labels : labelRequest,
    banks : bankRequest,
    payments : paymentRequest,
    credits : creditRequest,
    debits : debitRequest,
    salary_cats : salaryCatRequest,
    charges : chargeRequest,
    functions : functionRequest,
    services : serviceRequest,
    access : accessRequest,
    projects : projectRequest,
    steps : projectStepRequest,
    timesheets : timesheetRequest,
    advances : advanceRequest,
    advanceReturns : advanceReturnRequest,
    budgets : budgetRequest,
    posts : postRequest,
    incomes : incomeRequest,
    factures : factureRequest,
    transfers : transferRequest,
    chantiers : chantierRequest,
    equipements: equipementRequest,
    vehicules: vehiculeRequest,
    loans: loanRequest,
    loanDemands: loanDemandRequest,
    usages: usageRequest,
    localisations: localisationRequest,
    society: societyRequest,
    articles: articleRequest,
    demands: demandRequest,
    sessions: sessionRequest,

});

